import api from './api';

const assetTypeMasterService = {
  // Get all asset types
  getAllAssetTypes: async (params = {}) => {
    try {
      const response = await api.get('/asset-type-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset types:', error);
      throw error;
    }
  },

  // Get asset type by ID
  getAssetTypeById: async (id) => {
    try {
      const response = await api.get(`/asset-type-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset type:', error);
      throw error;
    }
  },

  // Create asset type
  createAssetType: async (data) => {
    try {
      const response = await api.post('/asset-type-master', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset type:', error);
      throw error;
    }
  },

  // Update asset type
  updateAssetType: async (id, data) => {
    try {
      const response = await api.put(`/asset-type-master/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset type:', error);
      throw error;
    }
  },

  // Delete asset type
  deleteAssetType: async (id) => {
    try {
      const response = await api.delete(`/asset-type-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset type:', error);
      throw error;
    }
  },

  // Get asset type statistics
  getAssetTypeStats: async () => {
    try {
      const response = await api.get('/asset-type-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset type statistics:', error);
      throw error;
    }
  },

  // Get next asset type code
  getNextAssetTypeCode: async () => {
    try {
      const response = await api.get('/asset-type-master/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next asset type code:', error);
      throw error;
    }
  }
};

export default assetTypeMasterService;

